"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _lodash = _interopRequireDefault(require("lodash"));

var _color = _interopRequireDefault(require("color"));

var _ProgressBar = _interopRequireDefault(require("../effect/ProgressBar"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _descriptor, _descriptor2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var KNOB_SIZE = 13;
var KNOB_RADIUS = 2;

var RangeSlider = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RangeSlider, _Component);

  var _super = _createSuper(RangeSlider);

  function RangeSlider() {
    var _this;

    (0, _classCallCheck2["default"])(this, RangeSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "containerEl", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "addedEventListeners", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    _this.lastReportedValue = void 0;

    _this.beginSlide = function (e) {
      if (!e.pageX) {
        return;
      }

      _this.removeDocumentEvents();

      _this.addDocumentListeners();

      _this.reportDragStart();
    };

    _this.onTouchMove = _lodash["default"].throttle(function (e) {
      _this.onDrag(e);
    }, 100);
    _this.onMouseMove = _lodash["default"].throttle(function (e) {
      _this.onDrag(e);
    }, 100);

    _this.onEnd = function (e) {
      _this.removeDocumentEvents();

      _this.reportDragStop();
    };

    _this.onBarClick = function (e) {
      if (e.pageX == null) {
        return;
      }

      var value = _this.valueFromPosition(e.pageX);

      if (value == null) {
        return;
      }

      _this.reportDragStart();

      _this.reportValue(value);

      _this.reportDragStop();
    };

    _this.onDrag = function (event) {
      if (event.pageX == null) {
        return;
      }

      var value = _this.valueFromPosition(event.pageX);

      if (value == null) {
        return;
      }

      _this.reportValue(value);
    };

    return _this;
  }

  (0, _createClass2["default"])(RangeSlider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeDocumentEvents();
    }
  }, {
    key: "addDocumentListeners",
    value: function addDocumentListeners() {
      window.document.addEventListener("mousemove", this.onMouseMove);
      window.document.addEventListener("mouseup", this.onEnd);
      window.document.addEventListener("touchmove", this.onTouchMove);
      window.document.addEventListener("touchend", this.onEnd);
      this.addedEventListeners = true;
    }
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {
      var addedEventListeners = this.addedEventListeners;

      if (addedEventListeners) {
        window.document.removeEventListener("mousemove", this.onMouseMove);
        window.document.removeEventListener("mouseup", this.onEnd);
        window.document.removeEventListener("touchmove", this.onTouchMove);
        window.document.removeEventListener("touchend", this.onEnd);
        this.addedEventListeners = false;
      }
    }
  }, {
    key: "valueFromPosition",
    value: function valueFromPosition(positionX) {
      var containerEl = this.containerEl;

      if (!containerEl) {
        return null;
      }

      var containerRect = containerEl.getBoundingClientRect();
      var containerLeft = containerRect.left + window.pageXOffset;
      var mouseXOffset = Math.max(0, Math.min(positionX - containerLeft, containerRect.width));
      var dragPercentage = mouseXOffset / containerRect.width;

      var _this$props = this.props,
          _this$props$range = (0, _slicedToArray2["default"])(_this$props.range, 2),
          minValue = _this$props$range[0],
          maxValue = _this$props$range[1],
          stepSize = _this$props.stepSize;

      var rawValue = minValue + dragPercentage * (maxValue - minValue); // value = stepSize * N + minValue

      var cleanN = Math.round((rawValue - minValue) / stepSize);
      return stepSize * cleanN + minValue;
    }
  }, {
    key: "reportDragStart",
    value: function reportDragStart() {
      var onDragStart = this.props.onDragStart;

      if (onDragStart) {
        onDragStart();
      }
    }
  }, {
    key: "reportDragStop",
    value: function reportDragStop() {
      var onDragStop = this.props.onDragStop;

      if (onDragStop) {
        onDragStop();
      }
    }
  }, {
    key: "reportValue",
    value: function reportValue(value) {
      var onChange = this.props.onChange;

      if (this.lastReportedValue == value) {
        return;
      }

      onChange({
        value: value
      });
      this.lastReportedValue = value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          className = _this$props2.className,
          style = _this$props2.style;
      var surfaceLight = this.context.theming.theme.surfaceLight;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(className, this.styles.root, style),
        ref: function ref(el) {
          return _this2.containerEl = el;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.barContainer)
      }, /*#__PURE__*/_react["default"].createElement(_ProgressBar["default"], {
        color: this.sliderColor,
        progress: this.progress,
        backgroundColor: surfaceLight,
        transitionDurationMs: 100
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.knobContainer),
        onClick: !disabled ? this.onBarClick : undefined
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.knob),
        onMouseDown: !disabled ? this.beginSlide : undefined,
        onTouchStart: !disabled ? this.beginSlide : undefined,
        onMouseUp: !disabled ? this.onEnd : undefined,
        onBlur: !disabled ? this.onEnd : undefined
      })));
    }
  }, {
    key: "isDragging",
    get: function get() {
      return this.addedEventListeners;
    }
  }, {
    key: "progress",
    get: function get() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          _this$props3$range = (0, _slicedToArray2["default"])(_this$props3.range, 2),
          min = _this$props3$range[0],
          max = _this$props3$range[1];

      return Math.max(Math.min(1, (value - min) / (max - min)), 0);
    }
  }, {
    key: "sliderColor",
    get: function get() {
      var disabled = this.props.disabled;
      var positive = this.context.theming.theme.positive;
      var fullColor = positive;

      if (disabled) {
        return new _color["default"](fullColor).whiten(0.9).hex();
      }

      return fullColor;
    }
  }, {
    key: "styles",
    get: function get() {
      var progress = this.progress,
          sliderColor = this.sliderColor,
          disabled = this.props.disabled,
          surfaceLightest = this.context.theming.theme.surfaceLightest;
      var knobLeft = "calc(".concat(Math.round(progress * 100), "% - ").concat(Math.round(KNOB_SIZE / 2 + KNOB_RADIUS), "px)");
      return _aphrodite.StyleSheet.create({
        root: {
          height: KNOB_SIZE + 2 * KNOB_RADIUS,
          position: "relative"
        },
        barContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "center",
          height: "100%"
        },
        knobContainer: {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          cursor: disabled ? "not-allowed" : "pointer"
        },
        knob: {
          position: "absolute",
          width: KNOB_SIZE,
          height: KNOB_SIZE,
          borderRadius: "100%",
          border: "solid 2px ".concat(sliderColor),
          backgroundColor: surfaceLightest,
          cursor: disabled ? "not-allowed" : "pointer",
          left: knobLeft,
          transition: "all 0.1s linear",
          transform: this.isDragging ? "scale(1.55, 1.55)" : "scale(1, 1)"
        }
      });
    }
  }]);
  return RangeSlider;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  value: {
    required: true,
    type: "number",
    description: "Current value of the slider"
  },
  range: {
    required: true,
    type: "[number, number]",
    description: "Range (min and max) value for the slider"
  },
  onChange: {
    required: true,
    type: "(args: { value: number }) => mixed",
    description: "Callback for when the value changes"
  },
  stepSize: {
    required: true,
    type: "number",
    description: "Minimum change in the value when the slider is moved"
  },
  disabled: {
    required: false,
    type: "?boolean",
    defaultValue: "false",
    description: "Indicates the slider is disabled"
  },
  onDragStart: {
    required: false,
    type: "?() => void",
    defaultValue: "null",
    description: "Callback for when dragging starts"
  },
  onDragStop: {
    required: false,
    type: "?() => void",
    defaultValue: "null",
    description: "Callback for when dragging ends"
  }
}, _class3.demoProps = [{
  value: 40,
  range: [0, 100],
  stepSize: 1,
  onChange: function onChange(_ref) {
    var value = _ref.value;
  }
}], _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "containerEl", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "addedEventListeners", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "isDragging", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isDragging"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "progress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "progress"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "sliderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sliderColor"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = RangeSlider;
exports["default"] = _default;